/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const types = {
  FETCH_ANALYTICS: "[Analytics] Fetch analytic",
  FETCH_ANALYTICS_SUCCESS: "[Analytics] Fetch analytic success",
  FETCH_ANALYTICS_FAILED: "[Analytics] Fetch analytic failed",

  FETCH_A_ANALYTIC: "[Analytics] Fetch a analytic",
  FETCH_A_ANALYTIC_SUCCESS: "[Analytics] Fetch a analytic success",
  FETCH_A_ANALYTIC_FAILED: "[Analytics] Fetch a analytic failed",

  FETCH_A_ANALYTIC_PUT_DATAPIPE: "[Analytics] Fetch a analytic put to datapipe",
  FETCH_A_ANALYTIC_PUT_DATAPIPE_SUCCESS:
    "[Analytics] Fetch a analytic put to datapipe",
  FETCH_ANALYTICS_RESTRICTION_LIST:
    "[Analytics] Fetch analytic restriction list",
  FETCH_ANALYTICS_RESTRICTION_LIST_SUCCESS:
    "[Analytics] Fetch analytic restriction list success",
  FETCH_ANALYTICS_RESTRICTION_LIST_FAILED:
    "[Analytics] Fetch analytic restriction list failed",
  CLEAR_ANALYTICS_RESTRICTION_LIST:
    "[Analytics] Clear analytic Restriction list",
  CLEAR_ANALYTICS_LIST: "[Analytics] Clear analytic list",
  CREATE_ANALYTICS_RESTRICTION: "[Analytics] Create analytic Restriction",
  CREATE_ANALYTICS_RESTRICTION_SUCCESS:
    "[Analytics] Create analytic Restriction Success",
  CREATE_ANALYTICS_RESTRICTION_FAILED:
    "[Analytics] Create analytic Restriction Failed",
  DELETE_ANALYTICS_RESTRICTION: "[Analytics] Delete analytic Restriction",
  DELETE_ANALYTICS_RESTRICTION_SUCCESS:
    "[Analytics] Delete analytic Restriction Success",
  DELETE_ANALYTICS_RESTRICTION_FAILED:
    "[Analytics] Delete analytic Restriction Failed",
};
//
// ─── FETCH ANALYTIC ACTIONS ────────────────────────────────────────────────────
//

export const FetchAnalytic = (customerId) => ({
  type: types.FETCH_ANALYTICS,
  payload: customerId,
});
export const FetchAnalyticsSuccess = (list) => ({
  type: types.FETCH_ANALYTICS_SUCCESS,
  payload: list,
});
export const FetchAnalyticsFailed = (error) => ({
  type: types.FETCH_ANALYTICS_FAILED,
  payload: error,
});
//
// ─── FETCH A ANALYTIC ACTIONS ────────────────────────────────────────────────────
//

export const FetchAAnalytic = (id) => ({
  type: types.FETCH_A_ANALYTIC,
  payload: id,
});
export const FetchAAnalyticSuccess = (list) => ({
  type: types.FETCH_A_ANALYTIC_SUCCESS,
  payload: list,
});
export const FetchAAnalyticFailed = (error) => ({
  type: types.FETCH_A_ANALYTIC_FAILED,
  payload: error,
});
//
// ─── FETCH A ANALYTIC PUT TO DATAPIPE ACTIONS ────────────────────────────────────────────────────
//

export const FetchAAnalyticPutToDatapipe = (data) => ({
  type: types.FETCH_A_ANALYTIC_PUT_DATAPIPE,
  payload: data,
});

export const FetchAAnalyticPutToDatapipeFailed = (error) => ({
  type: types.FETCH_A_ANALYTIC_PUT_DATAPIPE_FAILED,
  payload: error,
});

export const FetchAnalyticRestrictionList = (id) => ({
  type: types.FETCH_ANALYTICS_RESTRICTION_LIST,
  payload: id,
});

export const FetchAnalyticRestrictionListSuccess = (list) => ({
  type: types.FETCH_ANALYTICS_RESTRICTION_LIST_SUCCESS,
  payload: list,
});

export const FetchAnalyticRestrictionListFailed = (error) => ({
  type: types.FETCH_ANALYTICS_RESTRICTION_LIST_FAILED,
  payload: error,
});
export const ClearAnalyticRestrictionList = () => ({
  type: types.CLEAR_ANALYTICS_RESTRICTION_LIST,
});
export const ClearAnalyticList = () => ({
  type: types.CLEAR_ANALYTICS_LIST,
});

export const CreateAnalyticRestriction = (data) => ({
  type: types.CREATE_ANALYTICS_RESTRICTION,
  payload: data,
});
export const CreateAnalyticRestrictionSuccess = (response) => ({
  type: types.CREATE_ANALYTICS_RESTRICTION_SUCCESS,
  payload: response,
});
export const CreateAnalyticRestrictionFailed = (error) => ({
  type: types.CREATE_ANALYTICS_RESTRICTION_FAILED,
  payload: error,
});
export const DeleteAnalyticRestriction = (id) => ({
  type: types.DELETE_ANALYTICS_RESTRICTION,
  payload: id,
});
export const DeleteAnalyticRestrictionSuccess = (response) => ({
  type: types.DELETE_ANALYTICS_RESTRICTION_SUCCESS,
  payload: response,
});
export const DeleteAnalyticRestrictionFailed = (response) => ({
  type: types.DELETE_ANALYTICS_RESTRICTION_FAILED,
  payload: response,
});
